module.exports = __webpack_public_path__ + "static/img/11.7804191.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/zh/11.png
// module id = Rik2
// module chunks = 0